import React, { useState, useContext, useEffect, useCallback } from 'react';
import moment from 'moment';
import { assignItinerary as assignItineraryRequest } from 'modules/dispatching/service';

import { events } from './events';

const AssignmentContext = React.createContext();

export function AssignmentContextProvider({ eventEmitter, children }) {
  const [assignmentDate, setAssignmentDate] = useState(null);
  const [onAssignClick, setOnAssignClick] = useState(null);
  const [itineraryToAssign, setItineraryToAssign] = useState(null);
  const [itineraryRoute, setItineraryRoute] = useState(null);

  const parseDate = (date) => {
    if (!date) {
      return null;
    }
    return moment(date).format('YYYY-MM-DD');
  };

  const handleCheckCapacity = useCallback((data) => {
    const { date } = data || {};
    setAssignmentDate(parseDate(date));
    setItineraryToAssign(null);
    setItineraryRoute(null);
    setOnAssignClick(null);
  }, []);

  const assignItinerary = useCallback(
    async ({ driverId, vehicleIds, itineraryToAssign, assignmentReason, prebookingId = null }) => {
      if (onAssignClick) {
        onAssignClick({
          driverId,
          vehicleIds,
          itineraryToAssign,
          assignmentReason,
        });
        return;
      }
      try {
        await assignItineraryRequest({
          itineraryId: itineraryToAssign,
          driverId,
          vehicleIds,
          assignmentReason,
          prebookingId,
        });
      } catch (err) {
        console.error('Error assigning Itinerary', err);
      }
    },
    [onAssignClick]
  );

  const handleAssignItinerary = useCallback((data) => {
    const { date, itineraryId, itineraryRoute, onAssignClick } = data || {};
    setAssignmentDate(parseDate(date));
    setItineraryToAssign(itineraryId);
    setItineraryRoute(itineraryRoute);
    setOnAssignClick(() => onAssignClick);
  }, []);

  const clearAssignment = useCallback(() => {
    setAssignmentDate(null);
    setItineraryToAssign(null);
    setItineraryRoute(null);
    setOnAssignClick(null);
  }, []);

  useEffect(() => {
    eventEmitter.on(events.CHECK_CAPACITY, handleCheckCapacity);
    eventEmitter.on(events.ASSIGN_ITINERARY, handleAssignItinerary);
    return () => {
      eventEmitter.off(events.CHECK_CAPACITY);
      eventEmitter.off(events.ASSIGN_ITINERARY);
    };
  });

  const value = {
    assignmentDate,
    itineraryToAssign,
    itineraryRoute,
    assignItinerary,
    clearAssignment,
  };

  return <AssignmentContext.Provider value={value}>{children}</AssignmentContext.Provider>;
}

export const useAssignmentContext = () => {
  return useContext(AssignmentContext);
};

export default AssignmentContext;
